import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getCartItems } from "../../service/api/CartService";
import { loadCart } from "../../store/actions/cartActions";
import "./ContentHeader.scss";
import ShoppingCartIconOulined from '@mui/icons-material/ShoppingCartOutlined';

const ContentHeader = ({ titulo, totalItems }) => {

    const dispatch = useDispatch();

    useEffect(() => {
        getCartItems().then(items => {
            dispatch(loadCart(items));
        });
        // eslint-disable-next-line
    }, [totalItems]);


    return (
        <div className="content-header">
            <div className="container content">
                <Link to="/cart">
                    <div className="row justify-content-end">
                        <div className="col">
                            <div className="total-items font-weight-bold">{totalItems}</div>
                        </div>
                    </div>
                    <div className="shopping-cart"><ShoppingCartIconOulined /></div>
                    <p className="description">Tu cesta </p>
                </Link>
                <span className="row mt-5">
                    <h3 className="col-12">{titulo}</h3>
                </span>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        totalItems: state.totalItems
    }
}

export default connect(mapStateToProps)(ContentHeader)
